import { useEffect, useState } from 'react';

export function useVisualViewport() {
  const [viewportHeight, setViewportHeight] = useState(
    typeof window !== 'undefined' ? window.innerHeight : 0
  );
  const [viewportOffset, setViewportOffset] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      if (window.visualViewport) {
        setViewportHeight(window.visualViewport.height);
        setViewportOffset(window.visualViewport.offsetTop);

        // Expose as CSS variables for fallback usage
        document.documentElement.style.setProperty('--vh', `${window.visualViewport.height * 0.01}px`);
        document.documentElement.style.setProperty('--vvp-height', `${window.visualViewport.height}px`);
        document.documentElement.style.setProperty('--vvp-offset', `${window.visualViewport.offsetTop}px`);
      } else {
        setViewportHeight(window.innerHeight);
        document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
        document.documentElement.style.setProperty('--vvp-height', `${window.innerHeight}px`);
      }
    };

    // Initial set
    handleResize();

    // Add event listeners
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleResize);
      window.visualViewport.addEventListener('scroll', handleResize);
    } else {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleResize);
        window.visualViewport.removeEventListener('scroll', handleResize);
      } else {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  return { height: viewportHeight, offset: viewportOffset };
}
